import Color from '../Color.mjs'
import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'dfUserCode',
    name: '表业务主键',
    textProp: 'dfName',
    type: 'BK',
}
